import React, { useState, useEffect } from 'react'

Layout = require 'views/layouts/sidebar'
PageHeader = require 'components/header'
uiStore = require 'stores/ui'
{ Route, Switch, Redirect } = require 'react-router'
UserSettingsModal = require 'components/settings'
Welcome = require 'components/welcome'
PrivateRoute = require 'components/privateroute'
{ Grid, Col, Row, Button } = require 'reactstrap'
{ ListsIndex, CartsIndex } = require 'views/layouts/lists'
{ ListEditor, RdsListEditor } = require 'views/orders/editor'
Takeout = require 'views/orders/takeout'
Orders = require 'views/orders'
Reviews = require 'views/reviews'
import { OrderTab } from 'views/order/selector'
import { EditOrder, EditOrderTab } from 'views/order/v5/edit-order'

CartView = require 'views/carts'
Sidebar = require 'views/sidebar'

import Invoices from 'views/invoices'
import Invoice from 'views/invoices/invoice'
import { InvoiceAPICtx } from 'views/invoices/api'

import GraphQLApplication from './gql-context'

import { OrderAPI5 } from 'views/order/v5/api/order-state'
import { LiveLists, LiveListCards } from 'models/list-live'

import SecurityCheck from 'components/security-check'

Application = (props) ->
  orderAPI5Svc = ORDERS_SVC_API5.replace(/^http.?:\/\//, "wss://")

  <div>
    <SecurityCheck>
      <PageHeader />
      <Route exact path="/hello" component={Welcome} />
      <PrivateRoute path="/settings" component={UserSettingsModal} />
      <GraphQLApplication>
        <CSAuditService>
          <InvoiceAPICtx svc={PAYMENTS_SVC_API2}>
            <OrderAPI5 svc={orderAPI5Svc}>
              <LiveLists>
                <Layout>
                  <Switch>
                      <PrivateRoute exact path="/" component={Welcome} />
                      <PrivateRoute exact path="/invoices">
                        <Redirect to="/statements" />
                      </PrivateRoute>
                      <PrivateRoute exact path="/statements" component={Invoices} />
                      <PrivateRoute path="/statements/:invoiceType/:invoiceId/order/:orderUUID/transactions" component={Invoice} />
                      <PrivateRoute path="/statements/:invoiceType/:invoiceId" component={Invoice} />
                      <Route path="/invoices/:invoiceType/:invoiceId" render={
                        ({location: { pathname }}) -> <Redirect to={pathname.replace(/invoices/, 'statements')} />
                      } />
                      <PrivateRoute exact path="/lists/new" component={ListEditor} />
                      <PrivateRoute exact path="/lists" component={ListsIndex} />
                      <PrivateRoute exact path="/lists/:listId/edit" component={ListEditor} />
                      <PrivateRoute exact path="/lists/:listId/takeout" component={Takeout} />
                      <PrivateRoute exact path="/live/:listId/:orders(orders)?/:orderId?" component={LiveListCards} />
                      <PrivateRoute path="/lists/:listId/:order?/:orderId?" component={Orders} />
                      <PrivateRoute path="/lists/:listId/:order/:orderId/edit" component={EditOrder} />
                      <PrivateRoute path="/reviews/:selectorId/:order?/:orderId?" component={Reviews} />
                      <PrivateRoute path="/orders/:orderId/edit/:paymentId?" component={EditOrderTab} />
                      <PrivateRoute path="/orders/:orderId" component={OrderTab} />                      
                  </Switch>
                </Layout>
              </LiveLists>
            </OrderAPI5>
          </InvoiceAPICtx>
        </CSAuditService>
      </GraphQLApplication>
      <span>
        <Sound key="notification" soundId="notification" />
        <Sound key="neworder" soundId="neworder" />
      </span>
    </SecurityCheck>
  </div>

client = require('api/auth')
userStore = require('stores/user')
import { AuditService } from 'api/audit'

CSAuditService = ({children}) ->
  [loggedIn, setLoggedIn] = useState(false)
  useEffect ->
    userStore.loggedIn.onValue(setLoggedIn)
  , []
  token = if client.getAuthResponse() then client.getAuthResponse().access_token else null

  svc = RESTAURANTS_SVC_API5 + '/v5/audit_logs'
  if loggedIn && token
    <AuditService appId={'CustomerService'} svc={svc} auth_token={token} agent={"#{userStore.name()} <#{userStore.email()}>"}>{children}</AuditService>
  else
    <>{children}</>

Sound = ({soundId}) ->
  id = "noise-service-#{soundId}"
  mp3 = "../sounds/#{soundId}.mp3"
  ogg = "../sounds/#{soundId}.ogg"
  <audio id={id}>
    <h1>Your browser does not support audio playback. Please try using Chrome or Firefox.</h1>
    <source key="mp3" src={mp3}/>
    <source key="ogg" src={ogg}/>
  </audio>

module.exports = Application
